import React from 'react';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Document, BLOCKS, INLINES } from '@contentful/rich-text-types';
import { useRouter } from 'next/router';
import { FAQFORM_ID } from '@/config/constants';
import { Paragraph } from 'components/src/typography';
import Link from 'next/link';
import { formatLink } from '@/utils/utils';

type Props = {
  data: Document | undefined;
};

const RichTextContainer = ({ data }: Props) => {
  const router = useRouter();

  const scrollToFAQ = React.useCallback(
    (link: string) => {
      if (router.pathname === '/frelsi/fylla') {
        return link.includes('#spurningar');
      }
      return false;
    },
    [router.pathname]
  );

  return documentToReactComponents(data as Document, {
    renderNode: {
      [BLOCKS.PARAGRAPH]: (_node, children) => {
        return <Paragraph classes="text-black-100 empty:h-[18px]">{children}</Paragraph>;
      },
      [INLINES.HYPERLINK]: (node, children) => {
        return scrollToFAQ(node.data.uri) ? (
          <button
            className="text-md font-normal leading-[26px] text-red-100 hover:underline hover:decoration-red-100"
            onClick={() => {
              const elementPosition = document.getElementById(FAQFORM_ID)?.offsetTop;
              if (elementPosition) {
                window.scrollTo({
                  top: elementPosition - 25,
                  behavior: 'smooth',
                });
              }
            }}
          >
            {children}
          </button>
        ) : (
          <Link
            href={formatLink(node.data.uri)}
            className="text-md font-normal leading-[26px] text-red-100 hover:underline hover:decoration-red-100"
          >
            {children}
          </Link>
        );
      },
    },
  });
};
export default RichTextContainer;
